import React, { createContext, useContext, useState, useEffect } from 'react';
//import appConfig from '../../public/appConfig.json';

const ConfigContext = createContext();

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    CACHE_REFRESHER_DURATION: 1 // Default value: 1 minute
  });

  useEffect(() => {
    fetch('/appConfig.json')
      .then((response) => response.json())
      .then((config) => {
        setConfig((prevConfig) => ({
          ...prevConfig,
          ...config
        }));
      })
      .catch((error) => console.error('Failed to load configuration:', error));
  }, []);

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};

// configService.js
let config = null;

export const getConfig = async () => {
  if (!config) {
    try {
      const response = await fetch('/appConfig.json');
      const loadedConfig = await response.json();
      // console.log('response', loadedConfig)
      config = {
        ...loadedConfig,
        CACHE_REFRESHER_DURATION: loadedConfig.CACHE_REFRESHER_DURATION || 1 // Default to 1 minute if not provided
      };
    } catch (error) {
      console.error('Failed to load configuration:', error);
      config = {
        CACHE_REFRESHER_DURATION: 1 // Default to 1 minute if fetch fails
      };
    }
  }

  return config;
};
